import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeletePackagePaymentTransactionMutationVariables = GraphQLTypes.Exact<{
  paymentId: GraphQLTypes.Scalars['String'];
  transactionId: GraphQLTypes.Scalars['String'];
}>;


export type DeletePackagePaymentTransactionMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'deletePackagePaymentTransaction'>
);


export const DeletePackagePaymentTransactionDocument = /*#__PURE__*/ gql`
    mutation deletePackagePaymentTransaction($paymentId: String!, $transactionId: String!) {
  deletePackagePaymentTransaction(
    paymentId: $paymentId
    transactionId: $transactionId
  )
}
    `;

/**
 * __useDeletePackagePaymentTransactionMutation__
 *
 * To run a mutation, you first call `useDeletePackagePaymentTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackagePaymentTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackagePaymentTransactionMutation, { data, loading, error }] = useDeletePackagePaymentTransactionMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useDeletePackagePaymentTransactionMutation(baseOptions?: Apollo.MutationHookOptions<DeletePackagePaymentTransactionMutationResult, DeletePackagePaymentTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePackagePaymentTransactionMutationResult, DeletePackagePaymentTransactionMutationVariables>(DeletePackagePaymentTransactionDocument, options);
      }
export type DeletePackagePaymentTransactionMutationHookResult = ReturnType<typeof useDeletePackagePaymentTransactionMutation>;